import * as React from "react";
import { isUploadError, isUploadSuccess, uploadStatusError, uploadStatusIdle, isUploadIdle } from "../../types.js";
import { createNoFileError, getUploadErrorLabel } from "../../utils.js";
function useUploadHandler(props) {
  const [lastError, setLastError] = React.useState(() => {
    const { isRequired, hasError } = props.configs.reduce(
      ({ isRequired: isRequired2, hasError: hasError2 }, { required, uploadStatus }) => ({
        isRequired: isRequired2 || required,
        hasError: hasError2 || !!(uploadStatus && isUploadError(uploadStatus))
      }),
      { isRequired: false, hasError: false }
    );
    if (hasError || props.checkRequired && isRequired) {
      return createNoFileError();
    }
    return void 0;
  });
  const [, setIsSubmitted] = React.useState(!!props.checkRequired);
  const handlers = React.useRef(
    props.configs.reduce((h, { scope }) => ({ ...h, [scope]: getStatusChangeHandler(scope) }), {})
  );
  const [state, setState] = React.useState(
    props.configs.reduce((s, { scope, uploadStatus, required }) => {
      if (uploadStatus && isUploadSuccess(uploadStatus)) {
        return { ...s, [scope]: uploadStatus };
      }
      if (required && props.checkRequired) {
        return { ...s, [scope]: uploadStatusError(createNoFileError(), props.sharedErrorElementId) };
      }
      return { ...s, [scope]: uploadStatusIdle() };
    }, {})
  );
  function getStatusChangeHandler(scope) {
    const isRequired = props.configs.find(({ scope: scope2 }) => scope2 === scope2)?.required;
    return (statusUpdate) => {
      setIsSubmitted((prevIsSubmitted) => {
        setState(
          (prevState) => Object.entries(prevState).reduce((m, [key, status]) => {
            if (key === scope) {
              const possiblyError = isUploadError(statusUpdate) ? statusUpdate.error : null;
              const error = isUploadIdle(statusUpdate) && isRequired && prevIsSubmitted ? new Error("no-file") : possiblyError;
              setLastError(error || void 0);
              return {
                ...m,
                [key]: error ? uploadStatusError(error, props.sharedErrorElementId) : statusUpdate
              };
            }
            return { ...m, [key]: isUploadError(status) ? uploadStatusIdle() : status };
          }, {})
        );
        return prevIsSubmitted;
      });
    };
  }
  function checkMissingFiles() {
    let hasMissingFiles = false;
    const newState = props.configs.reduce((m, { scope, required }) => {
      if (required && !isUploadSuccess(state[scope])) {
        const error = createNoFileError();
        setLastError(error);
        hasMissingFiles = true;
        return { ...m, [scope]: uploadStatusError(error) };
      }
      return m;
    }, {});
    setState((prevState) => ({ ...prevState, ...newState }));
    setIsSubmitted(true);
    return hasMissingFiles;
  }
  return {
    lastError: lastError ? getUploadErrorLabel(lastError) : null,
    checkMissingFiles,
    state,
    handlers: handlers.current
  };
}
export {
  useUploadHandler
};
//# sourceMappingURL=use-upload-handler.js.map
